import { customAxios } from './customAxios';

export async function validaNotificaMonitoraggio(idNotifica, nota) {
    const config = {
        params: { id_notifica: idNotifica, nota },
        headers: {
            Accept: '*/*',
            'AuthToken': JSON.parse(localStorage.getItem('token')),
        },
    };
    try {
        const response = await customAxios.post(`${process.env.REACT_APP_BACKEND_HOST}/adv/monitoraggio/notifica/valida`, null, config);
        return response.data;
    } catch (error) {
        console.error('Errore durante la validazione della notifica:', error);
        throw error;
    }
}
